import { render, staticRenderFns } from "./DrivenSalesPage.vue?vue&type=template&id=023585a2&scoped=true&"
import script from "./DrivenSalesPage.vue?vue&type=script&lang=js&"
export * from "./DrivenSalesPage.vue?vue&type=script&lang=js&"
import style0 from "./DrivenSalesPage.vue?vue&type=style&index=0&id=023585a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023585a2",
  null
  
)

export default component.exports